import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'
import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {GitBranchIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'

export class StaticBranchFilterProvider extends SelectFilterProvider {
  constructor(branches: string[]) {
    const options = branches.map((branch, index) => ({
      value: branch,
      displayName: branch,
      priority: index + 1,
    }))

    super(
      {
        displayName: 'Branch',
        key: 'branch',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: GitBranchIcon,
        description: 'Filter by branch name',
      },
      options,
      {
        filterTypes: singleValueFilterTypes,
        // Git branch names are case-sensitive, so `branch:MAIN` must not match a `main` branch.
        caseSensitiveValues: true,
      },
    )
  }
}
